import React from 'react'
import { useSelector } from 'react-redux'
import GeolocMarker from './markers/GeolocMarker'
import TrafficLegend from './tools/TrafficLegend'
import ZoomButtons from './tools/ZoomButtons'
import Scale from './tools/Scale'
import Copyrights from './tools/Copyrights'
import Logo from './tools/Logo'
import ToggleFullscreenButton from './tools/ToggleFullscreenButton'
import OutdoorButton from './tools/OutdoorButton'
import Popup from './popup/Popup'
import UPI from '../outdoor/UPI'
import { selectIsQuizPage } from '../../store/history/history.selectors'
import GeolocButton from './tools/GeolocButton'
import Geolocation from './Geolocation'
import ContextMenu from './contextmenu/ContextMenu'
import MapDebugger from './debug/MapDebugger'
import MapProvider from './MapProvider'
import { selectIsVectorMap } from '../../store/map/map.selectors'
import VectorMap from './vector/VectorMap'
import RasterMap from './raster/RasterMap'
import MapAddressContour from './shape/MapAddressContour'

// webpack:BrowserOnly
const DynamicMap = ({ children }) => {
  const pageIsQuiz = useSelector(selectIsQuizPage)
  const vectorMap = useSelector(selectIsVectorMap)

  return (
    <MapProvider>
      {/*  Order matters : at least for GeolocMarker and GeolocButton */}
      <GeolocMarker />
      <GeolocButton />
      <Geolocation />
      <Scale />
      <Logo />
      <Copyrights />
      <ZoomButtons />
      {!pageIsQuiz && <OutdoorButton />}
      <TrafficLegend />
      <ToggleFullscreenButton />
      <UPI />
      <Popup />
      <ContextMenu />
      <MapAddressContour />
      <MapDebugger />
      {vectorMap ? <VectorMap /> : <RasterMap />}
      {children}
    </MapProvider>
  )
}

export default DynamicMap
